module.exports = __webpack_public_path__ + "img/slot-boong.464f729e.png";